export default __webpack_public_path__ + "static/media/poo-storm.8153c508.svg";